export enum FilterFieldTypeEnum {
    checkbox = 'checkbox',
    checkbox_list = 'checkbox_list',
    range = 'range',
}


type EntriesObjectGroupValues = {
    data: { [key: string]: string | number }
    // [key: string]: { data: { [key: string]: string | number } };
}

export type FilterCheckboxListFieldType = {
    type: FilterFieldTypeEnum.checkbox_list;
    title: string;
    count?: number;
} & EntriesObjectGroupValues;

export type FilterCheckboxFieldType = {
    type: FilterFieldTypeEnum.checkbox;
    title: string;
    count?: number;
}
export type FilterRangeType = {
    type: FilterFieldTypeEnum.range;
    title: string;
    count?: number;
    data: {
        min: number;
        max: number;
    }
}
export const guardFieldCheckboxType = (field: any): field is FilterCheckboxFieldType => {
    return (field as FilterCheckboxFieldType)?.type === FilterFieldTypeEnum.checkbox;
};

export const guardFieldCheckboxListType = (field: any): field is FilterCheckboxListFieldType => {
    return (field as FilterCheckboxListFieldType)?.type === FilterFieldTypeEnum.checkbox_list;
};
export const guardFieldRangeType = (field: any): field is FilterRangeType => {
    return (field as FilterRangeType)?.type === FilterFieldTypeEnum.range;
};
